export default __webpack_public_path__ + "static/media/@jakebadulake.57d5f88b.png";